import { render, staticRenderFns } from "./thumb-up.vue?vue&type=template&id=8152e8b0"
import script from "./thumb-up.vue?vue&type=script&lang=js"
export * from "./thumb-up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports